import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: ", ";\n  margin-bottom: 2px;\n  ", "\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    box-sizing: border-box;\n    width: 320px;\n    font-size: 14px;\n    line-height: 22px;\n    padding: 0px !important;\n    color: ", ";\n    transition: border-color 250ms ease-in-out;\n    background-color: transparent;\n    border: none;\n    @media screen and (max-width: ", "px) {\n      font-size: 16px;\n    }\n\n    &:-webkit-autofill,\n    &:-webkit-autofill:hover,\n    &:-webkit-autofill:focus,\n    &:-webkit-autofill:active {\n      transition: background-color 5000s ease-in-out 0s;\n    }\n\n    &:autofill,\n    &:autofill:hover,\n    &:autofill:focus,\n    &:autofill:active {\n      filter: none;\n      background: ", ";\n    }\n\n    &:focus,\n    &:hover {\n      outline: 0;\n      border-color: ", ";\n    }\n\n    &:disabled {\n      opacity: 0.3;\n      color: ", ";\n\n      &:hover {\n        border-color: ", ";\n      }\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: left;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    padding: 12px 15px;\n    border-radius: 10px;\n    border: 1px solid ", ";\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import MaskedInput from 'react-text-mask';
import styled, { css } from '../../utils/styling/styled-components';
import { TEXT_INPUT_ERROR, TEXT_INPUT_LABEL } from '../../utils/testing/TestIDs';
import { ErrorLabel } from './ErrorLabel';
var Container = styled.div(function (props) {
  return css(_templateObject(), function (props) {
    return props.theme.colors.ivoryLight;
  }, function (props) {
    return props.theme.colors.ivoryLight;
  }, props['data-error'] && "\n      border-color: ".concat(props.theme.colors.red, ";\n      color: ").concat(props.theme.colors.red, ";\n\n      &:focus, &:hover {\n        border-color: ").concat(props.theme.colors.red, ";\n      }\n    "));
});
var AdornmentContainer = styled.div(_templateObject2());
var DecoratorContainer = styled.div(_templateObject3());
var Input = styled.input(function (props) {
  return css(_templateObject4(), props.theme.colors.slate, function (props) {
    return props.theme.breakpoints.sm;
  }, function (props) {
    return props.theme.colors.ivoryLight;
  }, props.theme.colors.stone, props.theme.colors.stone, props.theme.colors.stoneLight);
});
var InputWithMask = Input.withComponent(MaskedInput);
var Label = styled.label(_templateObject5(), function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.disabled && "\n      opacity: 0.3;\n    ";
}, function (props) {
  return props.hidden && "\n      border: 0;\n      clip: rect(0 0 0 0);\n      height: 1px;\n      margin: -1px;\n      overflow: hidden;\n      padding: 0;\n      position: absolute;\n      width: 1px;\n    ";
});
var LabelContainer = styled.div(_templateObject6());

var BaseTextInputV3 = function BaseTextInputV3(_ref) {
  var className = _ref.className,
      adornments = _ref.adornments,
      error = _ref.error,
      errorText = _ref.errorText,
      decorators = _ref.decorators,
      inputProps = _ref.inputProps,
      label = _ref.label,
      ref = _ref.ref;
  var inputID = useMemo(function () {
    return (inputProps === null || inputProps === void 0 ? void 0 : inputProps.id) || uuid();
  }, [inputProps === null || inputProps === void 0 ? void 0 : inputProps.id]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Container, {
    className: className,
    "data-error": error
  }, /*#__PURE__*/React.createElement(LabelContainer, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: inputID,
    "data-testid": TEXT_INPUT_LABEL,
    disabled: inputProps.disabled,
    hidden: label.hidden || !label.value
  }, label.value), label.icon), decorators === null || decorators === void 0 ? void 0 : decorators.top, /*#__PURE__*/React.createElement(DecoratorContainer, null, decorators === null || decorators === void 0 ? void 0 : decorators.left, /*#__PURE__*/React.createElement(AdornmentContainer, null, (adornments === null || adornments === void 0 ? void 0 : adornments.left) && adornments.left, inputProps.mask ? /*#__PURE__*/React.createElement(InputWithMask, _extends({
    "data-error": error
  }, inputProps, {
    id: inputID
  })) : /*#__PURE__*/React.createElement(Input, _extends({
    "data-error": error
  }, inputProps, {
    id: inputID,
    ref: ref
  })), (adornments === null || adornments === void 0 ? void 0 : adornments.right) && adornments.right), decorators === null || decorators === void 0 ? void 0 : decorators.right)), decorators === null || decorators === void 0 ? void 0 : decorators.bottom, errorText && /*#__PURE__*/React.createElement(ErrorLabel, {
    "data-testid": TEXT_INPUT_ERROR,
    fieldId: inputID,
    errorText: errorText
  }));
};

export { BaseTextInputV3 };